<template>
    <div class="shop">
        <div class="shopHead">
            <div class="shopBanner">
                <img :src="detailsContent.icon" alt="">
            </div>
            <div class="shopContent">
                <div class="shopTitle">{{detailsContent.name}}</div>
                <div class="shopTag"><span v-for="item in detailsContent.label">{{item}}</span></div>
                <div class="shopPrice">
                    价格
                    <p>￥{{detailsContent.price}}/起</p>
                </div>
                <div class="shopList">
                    <div class="shopScore">
                        <p>综合评分<span><em>{{detailsContent.score}}</em>分</span></p>
                        <p>订单平均完成周期<span><em>{{detailsContent.cycle}}</em>周</span></p>
                        <p>订单平均响应时间<span><em>{{detailsContent.answer}}</em>小时</span></p>
                    </div>
                    <div class="shopConsult">立即咨询</div>
                </div>
            </div>
        </div>
        <!-- 详情图 -->
        <div class="shopImg">
            <div class="shopImgTitle">详情</div>
            <div class="shopImgList">
                <img v-for="item in detailsContent.content" :src="item" alt="">
            </div>
        </div>
        <div class="topBtn" v-if="tabbarBoxFixed" @click="topBtn"><img src="../images/home/icon_top.png" alt=""></div>
    </div>
</template>

<script>
    import { detailsList } from '../json/details';
    export default {
        name:'shop',
        data() {
            return {
                tabbarBoxFixed: false,
                detailsId: '',
                detailsContent: {},
            }
        },
        mounted(){
            window.scrollTo(0,0);
            if(this.$route.params.id != undefined){
                this.detailsId = this.$route.params.id;
                if(detailsList[`${this.$route.params.details}_${this.$route.params.id}`] == undefined){
                    this.$router.push('/404')
                }else{
                    this.detailsContent = detailsList[`${this.$route.params.details}_${this.$route.params.id}`];
                }
            }
            // 向页面添加事件
            window.addEventListener('scroll', this.handleScroll, true);
        },
        methods:{
            // 返回顶部
            topBtn(){
                window.scrollTo(0,0);
            },
            //滚动事件
            handleScroll() {
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                // var offsetTop = document.querySelector('#app').offsetTop // 获取所需元素到文档顶部的距离，然后判断滚动条位置让该元素是否固定定位
                if (scrollTop > 700) {
                    this.tabbarBoxFixed = true
                } else {
                    this.tabbarBoxFixed = false
                }
            },
        },
        destroyed() { //离开这个界面之后，删除滚动事件，不然容易除bug
            window.removeEventListener('scroll', this.handleScroll)
        },
    }
</script>

<style lang="scss" scoped>
    .shop{
        margin:0 auto 20px;
        width:$navWidth;
    }
    .shopHead{
        padding:24px;
        display: flex;
        justify-content: space-between;
        @include h-radius(0 0 5px 5px);
        @include h-bgColor(var(--colorFF));
        .shopBanner{
            width:42%;
            // width:488px;
            max-height:300px;
            overflow: hidden;
            @include h-radius(2px);
            img{
                height:100%;
                object-fit: cover;
            }
        }
        .shopContent{
            // padding-left:24px;
            width: 55%;
            // width: 640px;
            user-select: text;
            -webkit-user-select: text;
            .shopTitle{
                margin-bottom:15px;
                font-weight: bolder;
                @include h-fontSize(var(--color22),24px,38px);
            }
            .shopTag{
                display:flex;
                span{
                    padding: 0 8px;
                    margin-right:10px;
                    @include h-radius(2px);
                    @include h-border(1px solid var(--colorFe));
                    @include h-fontSize(var(--colorF66),14px,28px);
                }
            }
            .shopPrice{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin:20px 0 50px;
                @include h-fontSize(var(--color22),16px,22px);
                p{
                    font-weight: bold;
                    @include h-fontSize($colorF66,30px,48px);
                }
            }
            .shopList{
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                padding-top:40px;
                @include h-border(1px solid var(--colorEb),top);
                .shopScore{
                    width:40%;
                    p{
                        display: flex;
                        justify-content: space-between;
                        @include h-fontSize(var(--color22),16px,62px);
                        span{
                            em{
                                color:$colorF66;
                            }
                        }
                    }
                }
                .shopConsult{
                    @include h-btn(320px,64px,22px,$colorFF,5px,0,$colorF6,false,none);
                    height:64px;
                    cursor: pointer;
                    transition: background 0.3s;
                    &:hover{
                        @include h-bgColor($colorE7);
                    }
                }
            }
        }
    }
    .shopImg{
        margin:24px 0 0;
        padding:24px;
        @include h-radius(5px);
        @include h-bgColor(var(--colorFF));
        .shopImgTitle{
            display: flex;
            font-weight: bold;
            align-items: center;
            margin-bottom: 40px;
            @include h-fontSize(var(--color22),22px,38px);
            &::before{
                content: '';
                display: block;
                width:10px;
                height:20px;
                margin-right:10px;
                @include h-bgColor($colorF6);
            }
        }
        .shopImgList{
            img{
                width:80%;
                margin:0 auto;
            }
        }
    }
    .topBtn{
        bottom:100px;
        right:100px;
        z-index:100;
        width:38px;
        cursor: pointer;
        position: fixed;
        opacity: 0.8;
        transition: opacity 0.3s;
        &:hover{
            opacity: 1;
        }
    }
</style>